import API from '@/org-app/api';
import { createApiAction, createPostAction, createPutAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  getHeaderBidderSettings: createApiAction(
    API.instance.getComplexAuctionsConfigs,
    types.UPDATE_HEADER_BIDDER_SETTINGS,
    'messages.failedToGetHeaderBidderPresets',
  ),
  createHeaderBidderSettings: createPostAction(
    API.instance.createComplexAuctionsConfigs,
    types.UPDATE_HEADER_BIDDER_SETTINGS,
    'messages.failedToGetHeaderBidderPresets',
  ),
  updateHeaderBidderSettings: createPutAction(
    API.instance.updateComplexAuctionsConfigs,
    types.UPDATE_HEADER_BIDDER_SETTINGS,
    'messages.failedToGetHeaderBidderPresets',
  ),
};
